import { render, staticRenderFns } from "./FlightSearchResults.vue?vue&type=template&id=1a64f90d&scoped=true"
import script from "./FlightSearchResults.vue?vue&type=script&lang=js"
export * from "./FlightSearchResults.vue?vue&type=script&lang=js"
import style0 from "./FlightSearchResults.vue?vue&type=style&index=0&id=1a64f90d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a64f90d",
  null
  
)

export default component.exports